import flow from 'lodash/flow';
import values from 'lodash/values';
import flatten from 'lodash/flatten';

/**
 * @deprecated in favour of error-handlers@normaliseErrors
 * @param data
 * @returns {String|Array}
 */
export function validationMessages(data) {
    if (typeof data === 'object') {
        return flow(
            values,
            flatten,
        )(data);
    }

    return 'Something went wrong when submitting your request';
}

export function ajaxErrorResponse(response = {}, rethrow = true) {
    let errors = [];
    if (response.handled) {
        errors = response.errors;
    } else if (response.data && response.data.errors && typeof response.data.errors === 'object') {
        errors = validationMessages(response.data.errors);
    } else if (response.data && response.data.message) {
        errors.push(response.data.message);
    } else {
        errors.push("Something went wrong while processing your request");
    }

    let errorData = {
        errors,
        handled: true,
    };

    if (rethrow) {
        return Promise.reject(errorData);
    }

    return errorData;
}
